import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@insightai/ui'
import { MarketingPage, Section } from './MarketingPage'

const CAPABILITIES = [
  {
    title: 'Secondary research',
    body: 'Query decomposition across web, news, social, filings, review platforms and academic databases, synthesised under strict RAG with a source diversity score.',
  },
  {
    title: 'Quantitative fieldwork',
    body: 'AI questionnaire generation with design validation, respondent targeting, live quality screening, cross-tabs at 95% CI and key-driver analysis.',
  },
  {
    title: 'Qualitative sessions',
    body: 'Video focus groups and depth interviews with consent capture, observer rooms, stimulus sharing and multimodal affect analysis.',
  },
  {
    title: 'Descriptive tracking',
    body: 'Cross-sectional, longitudinal and omnibus designs with wording locked across waves so a trend break is never mistaken for a finding.',
  },
]

const SOLUTIONS = [
  { title: 'Brand health & tracking', body: 'Wave-on-wave tracking with significance markers and explicit tracking-break annotation.' },
  { title: 'Concept & product testing', body: 'Monadic and sequential designs with measurement governance applied before launch.' },
  { title: 'Market entry & sizing', body: 'Desk research first, primary research only where coverage is genuinely thin.' },
  { title: 'Category & shopper understanding', body: 'Qual and quant combined, with semiotic and motivational analysis layered on.' },
]

export function SolutionsPage() {
  return (
    <MarketingPage
      title="Capabilities & solutions"
      lede="Four research modes in one platform, with research-ops oversight across all of them."
    >
      <Section heading="Capabilities">
        <ul className="grid gap-4 sm:grid-cols-2">
          {CAPABILITIES.map((item) => (
            <li key={item.title}>
              <Card className="h-full">
                <CardHeader>
                  <CardTitle className="text-body">{item.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription>{item.body}</CardDescription>
                </CardContent>
              </Card>
            </li>
          ))}
        </ul>
      </Section>

      <Section id="solutions" heading="Common use cases">
        <ul className="flex flex-col gap-3">
          {SOLUTIONS.map((item) => (
            <li key={item.title} className="border-s-2 border-border-strong ps-4">
              <p className="text-body font-medium">{item.title}</p>
              <p className="text-body-sm text-text-secondary">{item.body}</p>
            </li>
          ))}
        </ul>
      </Section>
    </MarketingPage>
  )
}
